<template>
  <div class="page_socialInsurance">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="账户类型" size="small">
              <el-select v-model="listQuery.accountType" placeholder="" filterable clearable size="small" style="width: 180px;">
                <el-option value="自有账户"></el-option>
                <el-option value="供应商代参"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参保账户" size="small">
              <!-- <el-input v-model="listQuery.insuredAccountFullName" size="small" clearable style="width:180px"></el-input> -->
              <el-select v-model="listQuery.insuredAccountFullName" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商名称" size="small">
              <el-input v-model="listQuery.supplierName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item label="缴费类别" size="small">
            <el-select v-model="listQuery.accountFunction" placeholder="" filterable clearable size="small" style="width: 180px;">
              <el-option value="社保"></el-option>
              <el-option value="公积金"></el-option>
              <el-option value="社保+公积金"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参保省市区:">
            <el-cascader :props="propsAddress" filterable ref="cascaderArr" clearable v-model="address" :options="areaList" @change="changeAreaHandle" size="small" style="width: 180px;"></el-cascader>
          </el-form-item>
          <el-form-item label="创建人" size="small">
            <el-input v-model="listQuery.createUserName" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>社保</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <socialTab ref="child"></socialTab>
        <!-- <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="批次" name="0"></el-tab-pane>
          <el-tab-pane label="导入明细" name="1"></el-tab-pane>
        </el-tabs> -->

        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="importFee" v-if="checkPermission(['payFees_import'], permissionLists)">导入缴费标准</el-button>
          <el-button type="warning" size="small" @click="addNewFee" v-if="checkPermission(['payFees_add'], permissionLists)">手工新增</el-button>
          <el-button type="primary" size="small" @click="expList" :loading="isExping" v-if="checkPermission(['payFees_export'], permissionLists)">账户导出</el-button>
          <el-button type="primary" size="small" @click="expDtl" :loading="isExping2" v-if="checkPermission(['payFees_export'], permissionLists)">账户明细导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName2==0">
          <el-table-column prop="area" key="1" label="地区" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="accountType" key="2" label="账户类型" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="referenceCard" key="3" label="参保账户全称" min-width="240" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="supplier" key="4" label="供应商名称" min-width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="insuranceType" key="5" label="缴费类别" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="createUserName" key="6" label="创建人" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" key="7" label="合计金额" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="createTime" key="8" label="创建时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.createTime ? row.createTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="updateTime" key="9" label="更新时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.updateTime ? row.updateTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="pF_Email" label="公积金受理邮箱" min-width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="pF_TemplateUrl" label="公积金模板" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="downFile(row.pF_TemplateUrl,row.pF_FileName)" v-if="row.pF_TemplateUrl">{{ row.pF_FileName ? row.pF_FileName : '下载' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sS_Email" label="社保受理邮箱" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="sS_TemplateUrl" label="社保模板" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="downFile(row.sS_TemplateUrl,row.sS_FileName)" v-if="row.sS_TemplateUrl">{{ row.sS_FileName ? row.sS_FileName : '下载' }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="140" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="toDtl(row,'dtl')" v-if="checkPermission(['payFees_dtl'], permissionLists)">明细</el-button>
                <el-button type="text" @click="toDtl(row,'edit')" v-if="(row.isedit || roletype.indexOf('admin') != -1) &&checkPermission(['payFees_edit'], permissionLists)">编辑</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;" v-if="(row.isedit || roletype.indexOf('admin') != -1) && checkPermission(['payFees_del'], permissionLists)">
                  <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="导入缴费标准" :visible.sync="showImport" width="500px">
      <el-form :model="impForm" ref="impForm" label-width="100px">
        <el-form-item label="导入模板:" prop="phoneNum">
          <el-button type="text" class="blueName cp" @click="downImportTemp">下载模板</el-button>
        </el-form-item>
        <el-form-item label="导入缴费标准:" prop="fileUrl">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入缴费标准</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="confirmImport" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入账单确认" :visible.sync="showError" width="500px">
      <div class="errTips">以下账单已存在，请确认是否覆盖，或追加？</div>
      <el-table :data="errorList" border class="doc_table" style="width:100%">
        <el-table-column prop="name" label="账户" min-width="300" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="errorMsg" label="账单月" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="confirmImport(true)" :loading="isBtnLoading">覆盖</el-button>
        <el-button type="primary" size="small" @click="confirmImport(false)" :loading="isBtnLoading">追加</el-button>
      </span>
    </el-dialog>

    <el-dialog title="错误提示" :visible.sync="showError2" width="1000px">
      <el-table :data="errorList" border style="width: 100%" max-height="600px">
        <el-table-column prop="id" label="行号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="350" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="errorMsg" label="错误信息" min-width="500" align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="showError2 = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import socialTab from "./components/socialTab.vue"
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    components: {
      socialTab
    },
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          accountType: '',
          accountFunction: '',
          createUserName: '',
          accountFullName: '',
          serveProvince: '',
          serveCity: '',
          serveArea: '',
          supplierName: '',
          insuranceType: '',
          referenceCard: '',
          Userid:Cookies.get("userid-b"),
        },
        showDropScreen: -1,
        activeName: '缴费标准',
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
          checkStrictly: true
        },
        areaList: [],
        address: '',
        num1: 0,
        tableData: [],
        customerList: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        activeName2: '0',
        isExping: false,
        isExping2: false,
        showImport: false,
        showError: false,
        isBtnLoading: false,
        fileList: [],
        errorList: [],
        needLoading: false,
        showError2: false,
        permissionLists: [],
        legList: [],
        userId: Cookies.get("userid-b"),
        impForm: {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getButtonPower();
      this.getList();
      this.getMemberList();
      this.getprovinces();
      this.getlegalsubjectlist();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.getList()
          this.needLoading = false;
        } else {}
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/socialBill',
          powerEnName: 'socialBill'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let str = `GetSocialSubjectOfLegalAffairs?keyword=&pagesize=1000`
        xz.BasicGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then(res => {
          this.areaList = res;
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      // 获取人员列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.SocialFun(this.listQuery, 'GetJbBuSociaInsurancePolicyPageList', 'post').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '垫资成本') {
          this.$router.push({
            path: '/advCost'
          })
        }
      },
      importFee() {
        this.impForm = {
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        this.fileList = [];
        this.showImport = true;
      },
      downImportTemp() {
        var path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20250624102016850.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.setAttribute('download', '导入缴费标准模板.xlsx');
        aTag.click();
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.impForm.fileUrl = res;
          } else {
            this.impForm.fileUrl = '';
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制最多导入 1 个文件`);
      },
      // 删除
      handleFileRemove() {
        this.impForm.fileUrl = '';
      },
      confirmImport() {
        if (this.impForm.fileUrl) {
          this.isBtnLoading = true;
          xz.SocialFun(this.impForm, 'ImportSocialPolicy', 'post').then(res => {
            if (res.status == 'ok') {
              if (res.data.error != undefined && res.data.error.length > 0) {
                this.errorList = res.data.error;
                this.showError2 = true;
              } else {
                this.$message.success('保存成功');
              }
              this.getList();
              this.isBtnLoading = false;
              this.showImport = false;
              this.showError = false;
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.error('请导入文件');
        }
      },
      addNewFee() {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/addPayFee"
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      toDtl(row, type) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/addPayFee",
          query: {
            id: row.id,
            // insuranceType: row.insuranceType,
            type
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      del(row) {
        let d = {
          id: [row.id],
          userId: Cookies.get("userid-b"),
        }
        this.loading = true;
        xz.SocialFun(d, 'DeleteSecurityPolicy', 'post').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.getALLResponsible();
            this.loading = false;
            this.$message.success('删除成功');
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      expList() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.PageModel;
        xz.SocialExpFun(d, 'ExportJbBuSociaInsurancePolicyPageList').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `${this.activeName}列表.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      expDtl() {
        this.isExping2 = true;
        let d = {
          id: '',
          accountType: this.listQuery.accountType,
          reference_card: this.listQuery.insuredAccountFullName,
          supplierName: this.listQuery.supplierName,
          accountFunction: this.listQuery.accountFunction,
          username: this.listQuery.createUserName,
          reference_card: "",
          serveProvince: "",
          serveCity: "",
          serveArea: "",
          filename: `账户明细导出.xlsx`
        }
        xz.SocialExpFun(d, 'ExportSociaInsurancePolicyDetail/download').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `账户明细导出.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping2 = false;
            } catch (e) {
              this.isExping2 = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      changeAreaHandle(val) {
        if (val.length == 3) {
          this.listQuery.serveArea = val[2]
        } else if (val.length == 2) {
          this.listQuery.serveArea = val[1]
        } else if (val.length == 1) {
          this.listQuery.serveArea = val[0]
        } else {
          this.listQuery.serveArea = '';
        }
      },
      downFile(url, name) {
        var path = this.$store.state.EMP.tablePath + url;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', name);
        aTag.click();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }

  .errTips {
    font-size: 16px;
    margin-bottom: 10px;
  }
</style>
<style>
  .page_socialInsurance .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_socialInsurance .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_socialInsurance .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_socialInsurance .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_socialInsurance .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_socialInsurance .el-checkbox__label {
    padding-left: 3px;
  }

  .page_socialInsurance .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .el-tooltip__popper {
    max-width: 800px;
  }
</style>